module.exports = __webpack_public_path__ + "static/media/Twitterwithround.334c95bf.svg";